import { render, staticRenderFns } from "./OrderExchangeOrReturnReject.vue?vue&type=template&id=20a955ca&scoped=true"
import script from "./OrderExchangeOrReturnReject.vue?vue&type=script&lang=js"
export * from "./OrderExchangeOrReturnReject.vue?vue&type=script&lang=js"
import style0 from "./OrderExchangeOrReturnReject.vue?vue&type=style&index=0&id=20a955ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a955ca",
  null
  
)

export default component.exports